import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // import the updated router
import VueSelect from "vue-select"; // Import as default
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { DateTime } from 'luxon';
import axios from 'axios';
import LoadingOverlay from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import "vue-select/dist/vue-select.css";
import { useTransliteration } from '@/utils/useTransliteration'
// import '@/css-global/all.css';
import '@/css-global/custom-vendors.css';
import '@/css-global/form-elements.css';
import '@/css-global/header.css';
import '@/css-global/footer.css';
import '@/css-global/global.css';
import '@/css-global/variables.css';
import '@/css-global/fonts.css';
import '@/css-global/container.css';
import '@/css-global/grid.css';

// Import Chart.js components
import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
// Register Chart.js components globally
Chart.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);


// Create and mount the Vue app
const app = createApp(App);
const { toCyrillic, toLatin } = useTransliteration()
app.config.globalProperties.$toCyrillic = toCyrillic
app.config.globalProperties.$toLatin = toLatin
app.use(router); // use the router instance
app.config.globalProperties.$luxon = DateTime; // Global access to Luxon
app.config.globalProperties.$axios = axios;
app.component("v-select", VueSelect);
app.component('VueDatePicker', VueDatePicker);
app.component('LoadingOverlay', LoadingOverlay);
app.mount('#app');